import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
// import { DynamicSplashScreenComponent } from '../sharedComponents/splash-screen/splash-screen.component';

@Injectable({ providedIn: 'root' })
export class SplashScreenService
{
    private splashScreenInstance: any;

    constructor(private factoryResolver: ComponentFactoryResolver) { }

    public addDynamicSplashScreen(viewContainerRef: ViewContainerRef): void
    {
        // const component = this.factoryResolver.resolveComponentFactory(DynamicSplashScreenComponent);
        // this.splashScreenInstance = viewContainerRef.createComponent(component);
    }

    public closeSplashScreen(): void
    {
        if (!this.splashScreenInstance) { return; }
        this.splashScreenInstance.destroy();
    }
}
